export const BRACKETR_LAUNCH_DATE = Object.freeze({
  year: 2026,
  month: 5,
  day: 29,
  label: "29 May 2026",
});

export function bracketrBirthdayFor(date = new Date()) {
  const isAnniversary = date.getMonth() + 1 === BRACKETR_LAUNCH_DATE.month
    && date.getDate() === BRACKETR_LAUNCH_DATE.day;
  const age = date.getFullYear() - BRACKETR_LAUNCH_DATE.year;
  return {
    isBirthday: isAnniversary && age >= 1,
    age: Math.max(0, age),
  };
}
